import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { NbMenuItem, NbSidebarService } from "@nebular/theme";
import { ThemeService } from "@app/service/theme.service";

@Component({
  selector: "app-company-layout",
  templateUrl: "./company-layout.component.html",
  styleUrls: ["./company-layout.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [NbSidebarService]
})
export class CompanyLayoutComponent implements OnInit {
  public theme = "my-light-theme";

  menuItems: NbMenuItem[] = [
    {
      title: "New Company",
      icon: "briefcase-outline",
      link: "/company/company-initial"
    }
  ];

  constructor(
    private themeService: ThemeService,
    private sidebarService: NbSidebarService
  ) {}

  ngOnInit() {}
}
